import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Loader2, Save } from "lucide-react";

export const EditButton = ({ onSubmit, loading, success }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t">
      <Button onClick={onSubmit} disabled={loading}>
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Saving...
          </>
        ) : (
          <>
            <Save className="w-4 h-4 mr-2" />
            Save Changes
          </>
        )}
      </Button>
      <Link to="/profile">
        <Button variant="outline">Cancel</Button>
      </Link>
      {success && <span className="text-green-600 text-sm ml-2 self-center">{success}</span>}
    </div>
  );
};
